export default __webpack_public_path__ + "static/media/built-by-tomorrow.c1c7de64.svg";